import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

export function GoogleAnalytics() {
  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    trackPageView(pagePath);
  }, [location]);

  return null;
}
